import {createRoot} from 'react-dom/client'
// Axios
import { useEffect, useState } from 'react';

import axios from 'axios'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'

import {Chart, registerables} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {AppRoutes} from './app/AppRoutes'

import { useLang } from './_metronic/i18n/Metronici18n';

import { setupAxios } from './app/utils';

import { AuthProvider } from './app/context/auth';

import { GoogleOAuthProvider } from "@react-oauth/google";

import './assets/fonts/font.css'

import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'

import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'

import './app/App.css';

import 'katex/dist/katex.min.css';

import toastr from 'toastr';


Chart.register(...registerables, ChartDataLabels)

toastr.options.positionClass = 'toast-top-center'
toastr.options.preventDuplicates = true

const container = document.getElementById('root')

const GOOGLE_CLIENT_ID = window.env?.REACT_APP_GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID

if (container) {
  // Wrap your root component with LangProvider
  createRoot(container).render(
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID || ''}>
      <MetronicI18nProvider>
        <RootApp />
      </MetronicI18nProvider>
    </GoogleOAuthProvider>
  );
}

function RootApp() {
  const selectedLang = useLang();
  const [stylesLoaded, setStylesLoaded] = useState(false);

	useEffect(() => {
    const loadStyle = async () => {
      if (selectedLang == 'ar') {
        await import('./_metronic/assets/css/style.bundle.rtl.css');
      } else {
        await import('./_metronic/assets/css/style.bundle.css');
      }
      document.documentElement.lang = selectedLang;
      document.documentElement.dir = selectedLang === 'ar' ? 'rtl' : 'ltr';
      setStylesLoaded(true)
    };
    
	  loadStyle();

    setupAxios(axios, selectedLang)
	}, [selectedLang]);

  return (
    <AuthProvider>
      {stylesLoaded ? (
        <AppRoutes />
      ) : <></>}
    </AuthProvider>
  );
}